import { useState, useMemo } from "react";

const useSortTable = ({ data, initialConfig = null }) => {
  const [sortConfig, setSortConfig] = useState(initialConfig);

  const sortedData = useMemo(() => {
    if (!data) return [];

    // Create a shallow copy so we don't mutate the original Redux/state array
    let sortableItems = [...data];

    if (sortConfig !== null && sortConfig.key) {
      sortableItems.sort((a, b) => {
        // Handle properties object safely, fallback to top-level if not in properties
        const aValue = a.properties?.[sortConfig.key] ?? a[sortConfig.key];
        const bValue = b.properties?.[sortConfig.key] ?? b[sortConfig.key];

        // Push nulls/undefined to the bottom
        if (aValue === null || aValue === undefined || aValue === "") return 1;
        if (bValue === null || bValue === undefined || bValue === "") return -1;

        // Convert values to strings to ensure localeCompare works safely
        const stringA = String(aValue);
        const stringB = String(bValue);

        // Perform a natural, case-insensitive comparison
        const comparison = stringA.localeCompare(stringB, undefined, {
          numeric: true, // Sorts "2" before "10"
          sensitivity: "base", // Makes sorting case-insensitive (e.g., "a" == "A")
        });

        // Apply ascending/descending direction
        return sortConfig.direction === "ascending" ? comparison : -comparison;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);

  const requestSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  return { sortedData, requestSort, sortConfig };
};

export default useSortTable;
